<template>
  <div class="article-container">
    <div class="article" v-for="(news, index) in featuredNews" :key="'news-' + index">
      <a :href="articleUrl(news)"  class="article-image-link">
        <img :src="news.imageUrl" class="article-image" :alt="news.headers" />
        <h2 class="article-title">{{ news.headers }}</h2>
      </a>
      <p class="article-description">{{ truncatedDescription(news.description) }}</p>
      <a :href="articleUrl(news)" class="article-read-more">
        {{ language.wsm_ReadMore }} &gt;
      </a>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { attachSwipeArrows } from "../../../globalComponents/swipeArrows";
export default {
  name: "featuredNewsList",

  data() {
    return {
      featuredNews: [],
      tagId: "",
      language: this.$root.elementSettings.language,
    };
  },
  created: function () {
    this.tagId = this.$root.elementSettings.tagId || "";
    this.fetchFeaturedNews();
  },
  mounted: function () {
    this.detachSwipeArrows = attachSwipeArrows(this.$el, 767);
  },
  beforeDestroy: function () {
    if (this.detachSwipeArrows) {
      this.detachSwipeArrows();
    }
  },
  computed: {
    basedir: function () {
      return basedir;
    },
  },
  methods: {
    fetchFeaturedNews() {
      const newsQuery = {
        noOfResults: 3,
        sortOrder: "featured",
      };
      const parsedTagId = parseInt(this.tagId, 10);
      if (!isNaN(parsedTagId) && parsedTagId > 0) {
        newsQuery.tagId = parsedTagId;
      }

      return axios
        .get(
          window.basedir +
            "/ajaxRequestServlet?mode=Search&json=" +
            encodeURIComponent(JSON.stringify({ target: { news: newsQuery } }))
        )
        .then((response) => {
          this.featuredNews = response.data.news || [];
        })
        .catch((error) => {
          console.error("Failed to fetch featured news:", error);
        });
    },
    articleUrl(news) {
      return this.basedir + (news.urlPrefix || "/news/") + news.url;
    },
    truncatedDescription(description) {
      if (!description) {
        return "";
      }
      const trimmed = description.trim();
      return trimmed.length > 175
        ? trimmed.split(/\s+/).slice(0, 30).join(" ") + "..."
        : trimmed;
    },
  },
};
</script>

<style scoped>
.article-container {
  display: flex;
  gap: 20px;
  width: 1105px;
  margin: 15px auto;
  padding: 0 15px;
}

.article {
  flex: 0 0 calc((100% - 40px) / 3);
  min-width: 0;
}

.article-image-link {
  display: block;
  text-decoration: none;
}

.article-image {
  display: block;
  width: 100%;
  height: 225px;
  object-fit: cover;
  border-radius: 2px;
}

.article-title {
  position: relative;
  z-index: 1;
  margin: -35px 0 20px -7px;
  padding: 5px 10px;
  max-width: 90%;
  width: fit-content;
  min-height: 36px;
  font-size: 0.9em;
  font-weight: 700;
  line-height: 1.3;
  color: #fff;
  background: #004570;
  text-transform: uppercase;
  word-break: break-word;
  border-radius: 2px;
}



.article-read-more {
  display: inline-block;
  margin-top: 13px;
  font-size: 16px;
  font-weight: 400;
  color: #6cbce2;
  text-decoration: none;
}

.article-read-more:hover {
  text-decoration: underline;
}

@media screen and (max-width: 767px) {
  .article-container {
    box-sizing: border-box;
    width: 100%;
    padding: 15px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-padding-left: 15px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }

  .article-container::-webkit-scrollbar {
    display: none;
  }

  .article {
    flex: 0 0 80%;
    scroll-snap-align: start;
  }
}
</style>
